/* ============================================
   TIFFANY SOFA — JS Principal
   ============================================ */

'use strict';

async function addToCart(variantId, quantity) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Cart error');
    await updateCartCount();
    openCart();
  } catch (err) { console.error(err); }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (e) {}
}

function openCart() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; loadCartDrawer(); }
}

function closeCart() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
}

async function loadCartDrawer() {
  try {
    const res = await fetch('/?section_id=cart-drawer');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('.cart-drawer__content');
    const existingContent = document.querySelector('.cart-drawer__content');
    if (newContent && existingContent) existingContent.innerHTML = newContent.innerHTML;
  } catch (e) {}
}

document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();

  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = document.getElementById('cart-close');
  const cartOverlay = document.getElementById('cart-overlay');
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-menu-close');
  if (menuToggle && mobileMenu) menuToggle.addEventListener('click', () => { mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  if (mobileClose && mobileMenu) mobileClose.addEventListener('click', () => { mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; });

  // Variant selector (pages non-produit custom)
  const productForm = document.getElementById('product-form');
  if (!productForm) return;

  const variantSelect = document.getElementById('variant-select');
  const addBtn = document.getElementById('add-to-cart');
  const priceEl = document.getElementById('product-price');

  productForm.querySelectorAll('.product-option__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const optionIndex = btn.dataset.optionIndex;
      const value = btn.dataset.value;
      productForm.querySelectorAll(`.product-option__btn[data-option-index="${optionIndex}"]`).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const label = document.getElementById(`option-selected-${optionIndex}`);
      if (label) label.textContent = value;
      if (variantSelect) {
        const selectedValues = [];
        productForm.querySelectorAll('.product-option').forEach(opt => {
          const activeBtn = opt.querySelector('.product-option__btn.is-active');
          selectedValues.push(activeBtn ? activeBtn.dataset.value : null);
        });
        let matchedVariant = null;
        for (const option of variantSelect.options) {
          const parts = option.text.split('—')[0].trim().split(' / ');
          if (selectedValues.every((v, i) => !v || parts[i] === v)) { matchedVariant = option; break; }
        }
        if (matchedVariant) {
          variantSelect.value = matchedVariant.value;
          if (priceEl && matchedVariant.dataset.price) {
            const price = parseInt(matchedVariant.dataset.price) / 100;
            priceEl.textContent = price.toFixed(2).replace('.', ',') + ' €';
          }
          if (addBtn) addBtn.disabled = matchedVariant.disabled;
        }
      }
    });
  });
});

// Quick add
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.product-card__quick-add');
  if (!btn) return;
  if (btn.dataset.hasVariants) { window.location.href = btn.dataset.productUrl; return; }
  const variantId = btn.dataset.productId;
  if (!variantId) return;
  btn.disabled = true;
  btn.textContent = '✓ Ajouté !';
  await addToCart(variantId, 1);
  setTimeout(() => { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }, 1500);
});

// Gallery (hors page produit custom)
const galleryThumbs = document.getElementById('gallery-thumbs');
const galleryMain = document.getElementById('gallery-main');
if (galleryThumbs && galleryMain) {
  galleryThumbs.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      galleryThumbs.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      galleryMain.querySelectorAll('.product-gallery__slide').forEach(s => s.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const slide = galleryMain.querySelector(`.product-gallery__slide[data-index="${i}"]`);
      if (slide) slide.classList.add('is-active');
    });
  });
}

// Testimonials
const track = document.getElementById('testimonials-track');
const dotsContainer = document.getElementById('testimonials-dots');
const prevBtn = document.getElementById('prev-testimonial');
const nextBtn = document.getElementById('next-testimonial');
if (track && dotsContainer) {
  let current = 0;
  const perPage = window.innerWidth > 900 ? 3 : window.innerWidth > 600 ? 2 : 1;
  const totalPages = Math.ceil(track.querySelectorAll('.testimonial-card').length / perPage);
  for (let i = 0; i < totalPages; i++) {
    const dot = document.createElement('button');
    dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
    dot.setAttribute('aria-label', `Page ${i + 1}`);
    dot.addEventListener('click', () => goTo(i));
    dotsContainer.appendChild(dot);
  }
  function goTo(page) {
    current = Math.max(0, Math.min(page, totalPages - 1));
    track.style.transform = `translateX(-${current * 100}%)`;
    dotsContainer.querySelectorAll('.testimonials__dot').forEach((d, i) => d.classList.toggle('is-active', i === current));
  }
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
  setInterval(() => goTo((current + 1) % totalPages), 5000);
  let startX = 0;
  track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', e => { const diff = startX - e.changedTouches[0].clientX; if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1); });
}

// Filters
const filterToggle = document.getElementById('filter-toggle');
const filterPanel = document.getElementById('collection-filters');
const filterClose = document.getElementById('filter-close');
const applyFilters = document.getElementById('apply-filters');
if (filterToggle && filterPanel) {
  filterToggle.addEventListener('click', () => { filterPanel.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  if (filterClose) filterClose.addEventListener('click', () => { filterPanel.classList.remove('is-open'); document.body.style.overflow = ''; });
  if (applyFilters) applyFilters.addEventListener('click', () => {
    const url = new URL(window.location.href);
    filterPanel.querySelectorAll('input[type="checkbox"]:checked').forEach(input => url.searchParams.append(input.name, input.value));
    filterPanel.querySelectorAll('input[type="number"]').forEach(input => { if (input.value) url.searchParams.set(input.name, input.value); });
    window.location.href = url.toString();
    filterPanel.classList.remove('is-open');
    document.body.style.overflow = '';
  });
}

// Sort
const sortBy = document.getElementById('sort-by');
if (sortBy) sortBy.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', sortBy.value); window.location.href = url.toString(); });

// Cart page
document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(btn => {
  btn.addEventListener('click', () => {
    const key = btn.dataset.key;
    const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
    if (!input) return;
    const newVal = Math.max(0, parseInt(input.value, 10) + (btn.classList.contains('cart-qty-plus') ? 1 : -1));
    input.value = newVal;
    debounce(() => updateCartItem(key, newVal), 500)();
  });
});
document.querySelectorAll('.cart-item__remove').forEach(btn => {
  btn.addEventListener('click', async () => { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }) }); window.location.reload(); });
});
async function updateCartItem(key, quantity) {
  await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
  window.location.reload();
}

// Auth tabs
document.querySelectorAll('.auth-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.auth-tab').forEach(t => t.classList.remove('is-active'));
    document.querySelectorAll('.auth-form').forEach(f => f.hidden = true);
    tab.classList.add('is-active');
    const target = document.getElementById('tab-' + tab.dataset.tab);
    if (target) target.hidden = false;
  });
});

function debounce(fn, delay) { let timer; return function (...args) { clearTimeout(timer); timer = setTimeout(() => fn.apply(this, args), delay); }; }

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCart();
    const lightbox = document.getElementById('lightbox');
    if (lightbox && lightbox.classList.contains('is-open')) { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
});

// ============================================
// IntersectionObserver — animations [data-animate]
// Renders brand-story, testimonials and any
// other section that starts at opacity:0
// ============================================
(function() {
  function revealAll() {
    document.querySelectorAll('[data-animate]').forEach(el => el.classList.add('is-visible'));
  }
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-animate]').forEach(function(el) {
      observer.observe(el);
    });
  } else {
    revealAll();
  }
})();
